import type { SearchVehicle } from '../types'

export const floorAmount = ({ floorAmount: _floorAmount }: SearchVehicle): string => {
    if (!_floorAmount) {
        return 'No'
    }

    const numericFloorAmount = parseInt(_floorAmount, 10)

    return numericFloorAmount > 0 ? 'Yes' : 'No'
}
